import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_QUALIFICATION_TYPE: (id, qualificationType) => ({ id, qualificationType }),
    API: {
      UPDATE_QUALIFICATION_TYPE: apiResourceActionCreator('qualificationType')
    }
  }
})

export const apiAction = (authToken, qualificationTypeId, formData) => commonApiActions.authenticated.putFormData(`${API_ENDPOINT}/qualification-type/${qualificationTypeId}`, authToken, formData, actions.admin.api.updateQualificationType);

function* updateQualificationType(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.id, {
    data: action.payload.qualificationType,
  }));

  const result = yield apiActionResult(actions.admin.api.updateQualificationType);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.qualificationType }));
  }
}

const configuration = {
  name: 'updateQualificationType',
  action: actions,
  sagas: updateQualificationType,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateQualificationType.js